import React from 'react'
import {appApi} from '../../services';
import {Spin} from 'antd'
import {LeftPanel, Login} from '../common/templates/Login';
import { datavue } from '../../assets/images'
import {Redirect} from 'react-router-dom'
import {NOT_FOUND} from '../../constants/errorCodes'
import { handleAppError } from '../handlers';
import { loginPaths } from '../../constants/roleDetails';
import MFAConfirmation from '../common/templates/Login/MFAConfirmation';
import { withRouter } from 'react-router-dom';

class LoginPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      window_height: window.innerHeight,
      show_password:false,
      username:'',
      password:'',
      errors:{},
      mailSent: true,
      loginPath: '',
      secure_account: false
    }
  }

  enterHandler = (event) => {
    if(event.key === 'Enter') {
      this.handleLogin();
    }
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('keypress', this.enterHandler)
    window.addEventListener('resize', this.updateDimensions.bind(this))
  }

  componentWillMount() {
    sessionStorage.setItem('defaultSelectedTab', '9')
    window.removeEventListener('keypress', this.enterHandler)
    window.removeEventListener('resize', this.updateDimensions.bind(this))
  }

  updateDimensions() {
    this.setState({window_height: window.innerHeight})
  }

  handleLogin = async (e, apiType = 'login') => {

    let {username = '', password = ''} = this.state;

    username = username.trim();
    password = password.trim();
    if(username && password) {
      this.setState({isLoading: true});
      let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
      let api_url = window.API_URL;
      let cal_url = api_url.replace('/v1/', '');
      let mfa_token = ''
      if(apiType === 'mfaSkip') mfa_token = sessionStorage.getItem('mfa_token')

      const options = mfa_token ? { data: {mfa_token: mfa_token} } : { data: {password,email:username} }
      
      try {
        const response = await appApi[apiType](options);

        sessionStorage.setItem('mfa_token', response.data?.mfa_token)

        if(response.headers['x-ekincare-key']) {

          this.props.getLoginStatus(true);
          window.axios.defaults.headers.common['X-EKINCARE-KEY'] = response.headers['x-ekincare-key'];
          window.axios.defaults.headers.common['X-COMPANY-ID'] = response.data.company_id;
          sessionStorage.setItem('axiosHeaders', response.headers['x-ekincare-key']);
          sessionStorage.setItem('showPreEmp', response.data.enable_pre_emp);
          sessionStorage.setItem('hr_name', response.data.staff.name);
          function setRoleInSessionStorage(role) {
            sessionStorage.setItem('role', role);
            window.dispatchEvent(new Event('roleSet'));
          }
          setRoleInSessionStorage(response.data.role);
          sessionStorage.setItem('companies', JSON.stringify(response.data.companies?.filter(e => e.id !== undefined && e.id !== null)));
          sessionStorage.setItem('company_id', response.data.company_id);
          sessionStorage.setItem('logged_in_company_id', response.data.company_id)
          sessionStorage.setItem('company_name', response.data.staff.company_name);
          sessionStorage.setItem('is_child_company', JSON.stringify(response.data.parent_company_id));
          sessionStorage.setItem('hr_email', response.data.staff.email);
          sessionStorage.setItem('launch_date', response.data.launch_date);
          sessionStorage.setItem('is_active', response.data.is_active);
          sessionStorage.setItem(
            'calendar_url',
            cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + response.data.calendar_token + '/calendar.ics'
          );
          let is_active = sessionStorage.getItem('is_active');
          let role = sessionStorage.getItem('role');
          if(response.data.is_active === 'inactive' && role === 'staff'){
            this.setState({ redirect: true, isLoading: false, mailSent:  false, loginPath: '/mailer'});  
          }
          else{
            let sessionRole = sessionStorage.getItem('role')
            role = sessionRole ? sessionRole.toLowerCase().replace(/ /g, '_') : '/'
            this.setState({ redirect: true, isLoading: false, loginPath: loginPaths[role] });
          }
      }else{
        sessionStorage.setItem('mfa_enabled', response.data.mfa_enabled)
        sessionStorage.setItem('mfa_type', response.data.mfa_type)
        sessionStorage.setItem('username', username)

        if(response.data.mfa_enabled){
          this.setState({loginPath: '/mfa-otp', redirect: true, isLoading: false})
        }else{
          sessionStorage.setItem('role', response.data.role);
          this.setState({secure_account: true, redirect: false, isLoading: false})
        }
      }
      } catch(error) {
        let usernameerr = '', passworderr = '';
        const status = error && error.response && error.response.status;  
        if (status === NOT_FOUND) {
          if (error.response.data.message === "This account is not attached to the CSM role"){
            passworderr = error.response.data.message
          }else{
            passworderr = "The password or the username that you have entered is incorrect, please try again";
          }
        } else {
          handleAppError(error)
        }

        this.setState({
          isLoading: false,
          errors:{usernameerr, passworderr},
        });
      }
    } 
  }

  toggleVisiblity = (event) => {
    const element = document.getElementById('input_password');
    const type = element.type === 'password' ? 'text' : 'password';
    element.setAttribute('type', type);
    this.setState((prevState, _) => {
      return { show_password: !prevState.show_password };
    });
    event.stopPropagation();
  };

  setfields = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    let {errors} = this.state;
    errors = {
      ...errors,
      [[name]+'err']: value ? '':`Please input your ${name}!`,
    }
    
    this.setState({[name]:value, errors});
  }

  continueMFA =  () => {
    this.setState({loginPath: '/mfa-method', redirect: true, isLoading: false})
  }

  render() {
    let {redirect, isLoading} = this.state
    const {history} = this.props;
    if (redirect) {
      return <Redirect to={{pathname: `${this.state.loginPath}`, state: this.state}}  />
    }

    if (isLoading) {
      return (
        <div className="spiner">
          <Spin size="large" />
        </div>
      )
    }

    return (
      <div className='flex min-h-screen'>
        <LeftPanel />
        
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={datavue} alt='ekincare_logo' />
          { this.state.secure_account ? 
            <MFAConfirmation  continueMFA={this.continueMFA} skipMFA={this.handleLogin}/> :
            <Login {...this.state} setfields={this.setfields} handleLogin={this.handleLogin} handleForgot={this.handleForgot} toggleVisiblity={this.toggleVisiblity} history={history}/>
           }
        </div> 
      </div>
    )
  }
}

export default withRouter(LoginPage);
